import _sortBy from 'lodash/sortBy';

function Ctrl($scope, $rootScope, $timeout, $stateParams, utilsService, loggerService, modalService, membershipService, jsSdkMembershipPlan) {
  $scope.plan = {
    billingPrice: 49
  };

  $scope.membershipListPromise = jsSdkMembershipPlan.list();

  $scope.membershipListPromise.then(function(resp) {
    resp = _sortBy(resp, 'billingPrice');

    $scope.plan = resp[0];

  }, function() {
    loggerService.error('Failed to load membership plans.');
  });

  $scope.isSubscribed = function() {
    return membershipService.isUserSubscribed();
  };

  $scope.scrollTo = function(id, offset) {
    utilsService.scrollTo(id, offset);
  };

  $scope.concierge = function() {
    const msg = 'Hello Tablelist Concierge, I have a question about Tablelist Membership:';

    modalService.contactSupport({
      message: msg
    });
  };
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$timeout',
  '$stateParams',
  'utilsService',
  'loggerService',
  'modalService',
  'membershipService',
  'jsSdk.membershipPlan'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/membership/membershipCtrl.js